import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-gray-200 bg-gray-50" data-id="element-71">
      <div className="max-w-7xl mx-auto text-center" data-id="element-72">
        <p className="text-gray-900 font-bold tracking-widest uppercase mb-4 text-sm" data-id="element-73">
          Lighthouse Capital Group ™ 2026
        </p>
        <p className="text-gray-400 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-74">
          This website is not financial advice. Past deal performance is not a
          guarantee of future results. Lighthouse Capital Group is a buy-side
          M&A advisory firm. All transactions involve risk.
        </p>
      </div>
    </footer>;
}